<nav class="navbar navbar-expand-md navbar-light">
  <div class="total-logo"><img i18n-title="@@homeTip" src="./../../assets/TotalEnergies_logo.svg" class="logo" alt="TOTAL_Energies" title="Total Energies"></div>

  <div class="collapse navbar-collapse hide">
    <ul class="navbar-drpdwn" id="header-container">
      <div class="nav-drpdown">
      <li class="nav-item">
        <div ngbDropdown class="refineryDrpdwn">
          <div id="refinery" ngbDropdownToggle href="javascript:;">
            {{refineryName}}
          </div>
          <div ngbDropdownMenu class="refineryDrpDwn" aria-labelledby="refinery">
            <button class="dropdown-item" *ngFor="let refinery of refineryList" [id]="refinery"
                    (click)="populateTenant(refinery)">
              {{refinery}}
            </button>
          </div>
        </div>
      </li>
      <li class="nav-item">
        <div ngbDropdown>
          <div id="tenant" ngbDropdownToggle href="javascript:;">
            {{tenantName}}
          </div>
          <div ngbDropdownMenu class="tenantDrpDwn" aria-labelledby="tenant">
            <button class="dropdown-item" *ngFor="let tenant of tenantList" [id]="tenant.tenantName"
                    (click)="onTenantChange(tenant)">
              {{tenant.tenantName}}
            </button>
          </div>
        </div>
      </li>
  </div>
  <div class="nav-drpdown">
    <li class="nav-item pr-3 mr-3">
      <div class="btn-nav btn-home" (click)="goToHome()" matTooltip="Home"></div>
    </li>
    <!--
          //NOSONAR
        <li class="nav-item mr-3">
          <div class="btn-nav btn-notification" (click)="sidenav.toggle()" matTooltip="Notification">
            <span class="numberOfNotofocation" *ngIf="unreadNotifications > 0 && unreadNotifications < 10 && !hideNotificationNumber">{{unreadNotifications}}</span>
            <span class="numberOfNotofocation" *ngIf="unreadNotifications > 9 && !hideNotificationNumber">9+</span>
          </div>
        </li>
    <li class="nav-item pr-3 mr-3">
      <div class="btn-nav btn-help" (click)="mlServie.redirectTo(globals.config.platformDocumentation)" matTooltip="Help">
      </div>
    </li>-->
    <li class="nav-item userDetails">
      <div [title]="globals.userName">
        {{ (globals.userName && globals.userName.length>20)? (globals.userName | slice:0:20)+'...':(globals.userName) }}
      </div>
      <div>
        {{globals.rbacName}}
      </div>
    </li>
    <li class="nav-item userAvatar">
      <div class="row">
        <div class="col-md-3">
          <div ngbDropdown class="pr-2 profile" display="dynamic">
            <div class="centered cursor-pointer" id="username" ngbDropdownToggle>
              {{globals.userShortName | uppercase }}
            </div>
            <div ngbDropdownMenu aria-labelledby="profile">
              <div ngbDropdown class="cursor-pointer">
                <a class="dropdown-item cursor-pointer" (click)="openAboutRelease()">About Release</a>
              </div>
              <a class="dropdown-item" (click)="logout()">Sign out </a>
            </div>
          </div>
        </div>

      </div>
    </li>
  </div>
  </ul>
  </div>
</nav>

<!--
              //NOSONAR
            <mat-sidenav class="notificationPanel" #sidenav position="end" fixedInViewport="true"
             (opened)="notificationOpen()" (closedStart)="notificationClose()">
  <a class="cancelBtn cancelBtnPosn" (click)="sidenav.close()"></a>
  <div class="notificationsPanelBody">
    <ng-container *ngIf="!zeroNotification && !errorNotification && notification.length > 0;else noNotification">
      <div class="cursor-pointer notificationList" *ngFor="let element of notification; let i = index">
        <div class="notificationTile" *ngIf="i > -1 && i < notificationLimit;else noNotification" [ngClass]="element.acknowledged ? 'read':'unread'"
             (click)="mlServie.redirectToNotifiction(element.eventId, element.notificationMessage)">
          <div class="notificationHeading">
            <span class="notificationTitle">{{element.component}}</span>
            <span class="notificationDate">{{element.time | date: 'yyyy-M-dd T HH:mm:ss'}}</span>
          </div>
          <div class="clearfix"></div>
          <div>{{element.notificationMessage}}</div>
        </div>
      </div>
    </ng-container>
    <ng-template #noNotification>
      <div class="notificationList py-2 px-2" *ngIf="zeroNotification">No Notifications</div>
    </ng-template>
    <div class="notificationList" *ngIf="errorNotification">Error while fetching Notifications!</div>
    <button type="button" class="saveBtn2 actionBtn showallBtn" (click)="showAllNotification()" tabindex="-1"
            *ngIf="!zeroNotification && !errorNotification && notification.length > 9">
      Show All
    </button>
  </div>
</mat-sidenav> -->
